// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"tooltipWrapper__2-k7K","tooltip":"tooltip__6vhQv","display":"display__2C_mS"};